import React from "react";
import { BaseEdge, getStraightPath } from "reactflow";
import type { EdgeProps } from "reactflow";

const ConnectorEdgeComponent: React.FC<EdgeProps> = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    style,
    markerEnd,
    markerStart,
    interactionWidth,
}) => {
    const [edgePath] = getStraightPath({ sourceX, sourceY, targetX, targetY });
    // BaseEdge ignores className (path is always react-flow__edge-path); use a wrapper <g> for .connector-edge.
    return (
        <g className="connector-edge">
            <BaseEdge
                id={id}
                path={edgePath}
                style={style}
                markerEnd={markerEnd}
                markerStart={markerStart}
                interactionWidth={interactionWidth}
            />
        </g>
    );
};

export const ConnectorEdge = React.memo(ConnectorEdgeComponent);
